import React from 'react';
import PropTypes from 'prop-types';

const HideInfoIcon = ({
  color,
  size,
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 16 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.01311 3.95598L0.928443 1.87198L1.87178 0.92865L15.0711 14.1286L14.1278 15.0713L11.9211 12.8646C10.7486 13.6084 9.38827 14.0022 7.99978 14C4.40511 14 1.41444 11.4133 0.787109 7.99998C1.0738 6.44713 1.85486 5.02858 3.01378 3.95598H3.01311ZM9.83778 10.7813L8.86178 9.80532C8.48847 9.98393 8.06896 10.0423 7.66106 9.97251C7.25317 9.90267 6.87698 9.70802 6.58436 9.4154C6.29173 9.12278 6.09709 8.74659 6.02725 8.3387C5.95742 7.9308 6.01583 7.51128 6.19444 7.13798L5.21844 6.16198C4.79425 6.80298 4.60462 7.57087 4.68166 8.33564C4.7587 9.10041 5.09768 9.81506 5.64119 10.3586C6.1847 10.9021 6.89935 11.2411 7.66412 11.3181C8.42889 11.3951 9.19678 11.2055 9.83778 10.7813ZM5.31578 2.50665C6.14711 2.17998 7.05311 1.99998 7.99978 1.99998C11.5944 1.99998 14.5851 4.58665 15.2124 7.99998C15.0082 9.11045 14.549 10.1584 13.8711 11.0613L11.2978 8.48798C11.3742 7.97306 11.329 7.44739 11.1657 6.95309C11.0025 6.45878 10.7257 6.00959 10.3576 5.64149C9.9895 5.2734 9.54031 4.99663 9.04601 4.83337C8.5517 4.6701 8.02603 4.62488 7.51111 4.70132L5.31578 2.50732V2.50665Z"
      fill={color}
    />
  </svg>
);

HideInfoIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

HideInfoIcon.defaultProps = {
  color: '#656B7C',
  size: 16,
};

export default HideInfoIcon;
